export const addUserKey = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MOBILE: 'mobile',
  EMAIL: 'email',
  DESIGNATION: 'designation'
};
export const addUserLabel = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  MOBILE: 'Mobile Number',
  EMAIL: 'Email Id',
  DESIGNATION: 'Designation in the company'
};
